import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { HiArrowLeft, HiOutlineHome, HiOutlineSearch } from 'react-icons/hi';
import Button from '../../components/inputs/Button';

const QUICK_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Courses', path: '/programs' },
  { label: 'Gallery', path: '/gallery' },
  { label: 'About Us', path: '/about-us' }
];

function NotFound() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Purple Academy - Page Not Found';
  }, []);

  return (
    <section className="relative w-full overflow-hidden">
      {/* soft decorative glows */}
      <div className="pointer-events-none absolute -top-24 -left-24 w-72 h-72 rounded-full bg-primary/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -right-24 w-80 h-80 rounded-full bg-primary/10 blur-3xl" />

      <div className="content relative min-h-[calc(100vh-260px)] flex flex-col items-center justify-center text-center px-6 py-20">
        {/* ghosted 404 with search glyph */}
        <div className="relative flex items-center justify-center mb-2">
          <h1 className="font-title font-black text-[6.5rem] sm:text-[10rem] leading-none tracking-tighter bg-gradient-to-b from-primary to-[#5b0a4b] bg-clip-text text-transparent select-none">
            404
          </h1>
          <span className="absolute -right-2 -top-2 sm:right-4 sm:top-4 flex items-center justify-center w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-white shadow-lg border border-primary/10">
            <HiOutlineSearch className="w-6 h-6 sm:w-8 sm:h-8 text-primary" />
          </span>
        </div>

        <h2 className="font-title font-bold text-2xl sm:text-4xl text-textColor mb-4">
          Oops! Page not found
        </h2>
        <p className="text-base sm:text-lg text-textColor/70 max-w-xl mb-10">
          The page you&apos;re looking for doesn&apos;t exist, may have been moved,
          or is temporarily unavailable. Let&apos;s get you back on track.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Button
            onClick={() => navigate('/')}
            paddingX="px-8"
            paddingY="py-3"
            fontSize="text-base"
            className="rounded-lg w-full sm:w-auto gap-2"
          >
            <HiOutlineHome className="w-5 h-5" />
            Back to Home
          </Button>
          <Button
            onClick={() => navigate(-1)}
            bgColor="bg-transparent"
            textColor="text-primary"
            border
            paddingX="px-8"
            paddingY="py-3"
            fontSize="text-base"
            className="rounded-lg w-full sm:w-auto gap-2 hover:bg-primary/5"
          >
            <HiArrowLeft className="w-5 h-5" />
            Go Back
          </Button>
        </div>

        {/* quick links */}
        <div className="mt-14 w-full max-w-md">
          <p className="text-xs uppercase tracking-widest text-textColor/40 font-semibold mb-4">
            Or try one of these
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            {QUICK_LINKS.map(({ label, path }) => (
              <button
                key={label}
                type="button"
                onClick={() => navigate(path)}
                className="text-sm font-medium text-primary hover:underline underline-offset-4"
              >
                {label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default NotFound;
